import React from 'react';
import { Provider } from 'react-redux';
import {store, persistor } from './stateManagment/Store';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './components/App';
// import {BrowserRouter} from 'react-router-dom'
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { PersistGate } from 'redux-persist/integration/react';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);


{/* <>
{/* <Provider store={store}> */}
  {/* <PersistGate  persistor={persistor }> */}
    {/* <React.StrictMode> */}
      // <App />
    {/* </React.StrictMode> */}
  {/* </PersistGate> */}
{/* </Provider> */}
  
// </>